import { DashboardFrameFooter, DashboardFrameHeader, FrameData } from 'domain/entity/dashboard';
import Profile from 'domain/entity/profile';
import placeholderLogo from './placeholderLogo.png';

export const getA4HeaderText = (frameConfig: DashboardFrameHeader | undefined, templateName: string, profile: Profile): string => {
    if (!frameConfig || !profile) {
        return '';
    }
    const activeKeys = getActiveKeys(frameConfig);
    const frameData = getFrameData({ activeKeys, templateName, profile });

    const templateNameText = frameData.templateName ? `<span style="margin-left: 10px;">${frameData.templateName}</span>` : '';
    const periodText = frameData.period ? `<span style="margin-left: 10px;">${frameData.period}</span>` : '';
    const locationText = frameData.location ? `<span style="margin-left: 10px;">${frameData.location}</span>` : '';

    const textParts: string[] = [];

    if (frameData.templateName) textParts.push(templateNameText);
    if (frameData.period) textParts.push(periodText);
    if (frameData.location) textParts.push(locationText);

    const separator = `<span style="margin-left: 10px; color: gray;"> | </span>`;
    const stringToPrint = textParts.join(separator);

    const image = frameData.logo ? `<img src="${frameData.logo}" alt="Logo" style="vertical-align: middle;" />` : '';
    const stringToPrintWithImage = image + stringToPrint;

    return stringToPrintWithImage;
};

export const getA4FooterText = (frameConfig: DashboardFrameFooter | undefined, widgetCriteriaId: string): string => {
    if (!frameConfig) {
        return '';
    }

    const activeKeys = getActiveKeys(frameConfig);
    const frameData = getFrameData({ activeKeys, widgetCriteriaId });

    const textParts: string[] = [
        frameData.generationDate ? `<p>${frameData.generationDate}</p>` : `<p> </p>`,
        frameData.pageNumber ? `<p style="margin-left: 10px;">${frameData.pageNumber}</p>` : '',
    ].filter((v): v is string => Boolean(v));

    const stringToPrint = `
        <div>
            ${textParts.join('')}
        <div>
    `;

    return stringToPrint;
};

const getActiveKeys = (frameConfig: any): string[] => {
    if (!frameConfig) {
        return [];
    }

    return Object.keys(frameConfig).filter((key) => (frameConfig as any)[key]);
};

const getPageNumber = (widgetCriteriaId: string): string => {
  const number =
    parseInt(widgetCriteriaId.split('_').pop() || '0', 10) + 1;

  return number.toString();
};

const getFrameData = ({ activeKeys, templateName, profile, widgetCriteriaId }: { activeKeys: string[]; templateName?: string; profile?: Profile; widgetCriteriaId?: string }): FrameData => {
    const frameData: FrameData = {};
    const pageNumber = widgetCriteriaId ? getPageNumber(widgetCriteriaId) : '';

    activeKeys.forEach((key) => {
        switch (key) {
            case 'logo':
                frameData[key] = placeholderLogo;
                break;
            case 'templateName':
                frameData[key] = templateName || '';
                break;
            case 'period':
                // Placeholder value to be displayed in the template
                frameData[key] = 'DD/MM/YYYY - DD/MM/YYYY';
                break;
            case 'location':
                frameData[key] = (profile && profile.locationName) || '';
                break;
            case 'generationDate':
                // Placeholder value to be displayed in the template
                frameData[key] = 'Generated: DD/MM/YYYY';
                break;
            case 'pageNumber':
                frameData[key] = pageNumber || '1';
                break;
            default:
                break;
        }
    });

    return frameData;
};
